// Thin wrapper around the Browser Notification API. Permission is requested only
// when the user turns Desktop notifications on. All user-facing text is Hebrew.

export const isSupported = () => typeof window !== "undefined" && "Notification" in window;

export const getPermission = () => (isSupported() ? Notification.permission : "denied");

// Returns { granted: boolean, blocked: boolean, message: string|null }
export async function requestPermission() {
  if (!isSupported()) {
    return { granted: false, blocked: true, message: "הדפדפן אינו תומך בהתראות מחשב" };
  }
  if (Notification.permission === "granted") {
    return { granted: true, blocked: false, message: null };
  }
  if (Notification.permission === "denied") {
    return { granted: false, blocked: true, message: "ההרשאה להתראות נחסמה בדפדפן" };
  }
  const result = await Notification.requestPermission();
  if (result === "granted") return { granted: true, blocked: false, message: null };
  if (result === "denied") return { granted: false, blocked: true, message: "ההרשאה להתראות נחסמה בדפדפן" };
  return { granted: false, blocked: false, message: "יש לאשר הרשאות התראה בדפדפן" };
}

// Decides whether to show a desktop notification for an incoming SSE event,
// based on the per-type desktop toggle and the global display mode.
export function shouldDisplayDesktop({ desktop_enabled, desktop_display_mode }) {
  if (!desktop_enabled) return false;
  if (getPermission() !== "granted") return false;
  if (desktop_display_mode === "always") return true;
  // when_tab_inactive (default): only when the tab is hidden / unfocused
  return document.hidden || !document.hasFocus();
}

// Shows the notification; clicking it focuses the app and navigates to link_url.
export function showDesktopNotification({ title, message, link_url }) {
  if (getPermission() !== "granted") return;
  try {
    const n = new Notification(title || "התראה חדשה", {
      body: message || "",
      lang: "he",
      dir: "rtl",
      tag: link_url || undefined,
    });
    n.onclick = () => {
      window.focus();
      if (link_url) window.location.assign(link_url);
      n.close();
    };
  } catch {
    // Some browsers throw if constructed without a user gesture — ignore silently.
  }
}
